/**
 * ModuleInlineBadge - Kompaktes Badge fuer Inline-Nutzung
 *
 * P0 UX: BETA-Kennzeichnung in operativer Erfassung
 *
 * Kompakte Variante von ModuleBadge fuer:
 * - Neben Ueberschriften
 * - In Dialog-Headers
 * - Inline mit Text
 *
 * Zeigt Badge nur bei BETA/EXPERIMENTAL/DEPRECATED
 */

import { useModules, MATURITY_STYLES, MATURITY_LABELS } from '../hooks/useModules';
import { Tooltip } from './Tooltip';

interface ModuleInlineBadgeProps {
  moduleKey: string;
  className?: string;
}

export function ModuleInlineBadge({ moduleKey, className = '' }: ModuleInlineBadgeProps) {
  const { getModule, loading } = useModules();

  if (loading) {
    return null;
  }

  const moduleData = getModule(moduleKey);

  // Nicht gefunden oder STABLE: nichts rendern
  if (!moduleData || moduleData.maturity === 'STABLE') {
    return null;
  }

  const label = MATURITY_LABELS[moduleData.maturity];
  const styles = MATURITY_STYLES[moduleData.maturity];

  return (
    <Tooltip content={moduleData.tooltip} className={className}>
      <span
        className={`
          inline-flex items-center px-1.5 py-0.5 text-xs font-medium 
          border rounded
          ${styles}
        `}
        role="status"
        aria-label={`${label}: ${moduleData.tooltip}`}
      >
        {label}
      </span>
    </Tooltip>
  );
}
